import Button from '@mui/material/Button';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch } from '../../../../redux/hooks';
import { logoutUser } from '../../../../redux/slices/userSlice';

interface LogoutButtonProps {
  header?: boolean;
}

const LogoutButton = ({ header = false }: LogoutButtonProps) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await dispatch(logoutUser()).unwrap();
      navigate('/login');
    } catch (error) {
      console.error('Logout error:', error);
      // Even if logout fails, navigate to login
      navigate('/login');
    }
  };

  return (
    <Button
      variant={header ? 'outlined' : 'contained'}
      color='inherit'
      onClick={handleLogout}
      sx={{
        borderColor: header ? 'rgba(255, 255, 255, 0.5)' : undefined,
        color: header ? 'white' : undefined,
        '&:hover': {
          borderColor: header ? 'white' : undefined,
          backgroundColor: header ? 'rgba(255, 255, 255, 0.1)' : undefined,
        },
      }}
    >
      Cerrar Sesión
    </Button>
  );
};

export default LogoutButton;
